import { Drawer } from '@billy/design-system'
import { Suspense } from 'react'

import { SelectedTransaction } from '@features/transactions/types/selectedTransaction'

import { TransactionDrawerContextProvider } from '../../contexts/TransactionDrawerContext'
import { TransactionDrawerBody } from '../../elements/TransactionDrawerBody'
import { TransactionDrawerSkeleton } from '../../elements/TransactionDrawerSkeleton'
import { useTransactionDrawerUrlSync } from '../../hooks/useTransactionDrawerUrlSync'

interface DrawerContentProps {
  id: string
  onSelectTransaction: (transaction: SelectedTransaction) => void
  transactionNo: number | null | undefined
}

export const DrawerContent = ({ id, onSelectTransaction, transactionNo }: DrawerContentProps) => {
  useTransactionDrawerUrlSync(id)

  return (
    <Drawer closable>
      <Suspense fallback={<TransactionDrawerSkeleton transactionNo={transactionNo} />}>
        <TransactionDrawerContextProvider onSelectTransaction={onSelectTransaction} transactionId={id}>
          <TransactionDrawerBody />
        </TransactionDrawerContextProvider>
      </Suspense>
    </Drawer>
  )
}
